import { render, staticRenderFns } from "./excitingReview.vue?vue&type=template&id=27c15230&scoped=true&"
import script from "./excitingReview.vue?vue&type=script&lang=js&"
export * from "./excitingReview.vue?vue&type=script&lang=js&"
import style0 from "./excitingReview.vue?vue&type=style&index=0&id=27c15230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c15230",
  null
  
)

export default component.exports